import { computed, ref } from 'vue';
import { centralConfigurationService } from '../services/api/centralConfiguration.service';
import { PlatformEnum } from '../enums/platform.enum';

export function useLoginAnnouncement() {
  const text = ref<string>('');
  const message = computed(() => text.value);
  const platform = PlatformEnum.WEB;

  const fetch = async (): Promise<void> => {
    try {
      text.value = (await centralConfigurationService.getLoginImportantInformation(platform)) || '';
    } catch (error) {
      text.value = '';
    }
  };

  return {
    message,
    fetch,
  };
}
